export const environment = {
  appsUrl: 'https://apps.enplug.in'
};
